import "./InternalTraining.scss";
import "moment/locale/fr";
import InfoContext from "pages/InfoContext";
import Label from "core/label/Label";
import { FormattedMessage, useIntl } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { useContext } from "react";
import { getFormattedDate, renderCommentValue } from "utils/functions";
import { FORM_INFO } from "constants/forms";
import InputText from "core/inputs/input-text/InputText";
import {
  ACTIONS,
  DATATRACK_MODELS,
  ROLE_MATCH_MODE,
  SCOPES,
} from "constants/constants";
import { ROLE_CREATE_BY_MODEL, ROLE_DELETE_BY_MODEL } from "access-roles/roles";
import { canUserPerformAction } from "access-roles/general-functions";

const InternalTraining = () => {
  const intl = useIntl();
  const {
    internalTraining,
    internalTrainingComments,
    commentAction,
    lang,
    userRoleList,
    userScope,
  } = useContext(InfoContext);
  const model = DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS;

  const {
    comment_settings,
    comment_settings: { title: comment_label, type: comment_type },
  } = FORM_INFO.comment_internal_training || {};

  const formatInternalTraining = (payload) =>
    payload?.map((elm) => ({
      training_date: getFormattedDate(elm.training_date, lang),
      training_name: elm.training_name,
      training_attended: (
        <Label
          id={`it-${elm.id}`}
          className="medium"
          label={
            elm.training_attended
              ? intl.formatMessage({
                  id: "present",
                  defaultMessage: "Présent",
                })
              : intl.formatMessage({
                  id: "absent",
                  defaultMessage: "Non présent",
                })
          }
          color={elm.training_attended ? "light-lime-green" : "cosmos"}
        />
      ),
    }));

  const header = [
    {
      label: {
        key: "training_date",
        value: <FormattedMessage id="dates_label" defaultMessage="Dates" />,
      },
      icon: "calendar",
      width: "20%",
    },
    {
      label: {
        key: "training_name",
        value: (
          <FormattedMessage
            id="training_name_label"
            defaultMessage="Nom de la formation"
          />
        ),
      },
      icon: "event",
      width: "50%",
    },
    {
      label: {
        key: "training_attended",
        value: (
          <FormattedMessage
            id="training_attendace_label"
            defaultMessage="Présence à la formation"
          />
        ),
      },
      icon: "check-list",
      width: "30%",
    },
  ];
  return (
    <div className="section-n  internal-training">
      <div className="internal-training-table">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="internal_training_title"
              defaultMessage="Formations internes"
            />
          }
        />
        <Typography
          className="title-4 light-slate-gray "
          type="h4"
          label={
            <FormattedMessage
              id="internal_training_subtitle"
              defaultMessage="Formations internes auxquels le consultant s'est inscrit (historique complet)"
            />
          }
        />
        <div>
          <Table
            id="internal_training"
            header={header}
            content={formatInternalTraining(internalTraining)}
            maxWidth="1096px"
          />
        </div>
      </div>
      <div className="internal-training-comments">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage id="comments" defaultMessage="Commentaires" />
          }
        />
        <div className="commentary_cell">
          <InputText
            comments={internalTrainingComments}
            id={comment_type}
            label={comment_label}
            isUnderline={internalTrainingComments?.length > 0}
            marginLeft={15}
            readOnly={true}
            commentSettings={comment_settings}
            addComment={(val) => {
              val &&
                commentAction({
                  action: ACTIONS.CREATE,
                  content: val,
                  model,
                });
            }}
            value={renderCommentValue(internalTrainingComments, intl)}
            lang={lang}
            commentAction={commentAction}
            isCommentsInput={true}
            model={model}
            canUserCreateComment={
              userScope !== SCOPES.READ &&
              canUserPerformAction({
                userRoles: userRoleList,
                requiredRoles: [
                  ROLE_CREATE_BY_MODEL.internal_training_comments,
                ],
                mode: ROLE_MATCH_MODE.OR,
              })
            }
            canUserDeleteComment={
              userScope !== SCOPES.READ &&
              canUserPerformAction({
                userRoles: userRoleList,
                requiredRoles: [
                  ROLE_DELETE_BY_MODEL.internal_training_comments,
                ],
                mode: ROLE_MATCH_MODE.OR,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default InternalTraining;
